<template>
    <div class="esign-settings">
        <SettingsTemplate backUrl="/settings/home/external" :menuItems="menu" />
    </div>
</template>

<script>
import SettingsTemplate from 'vcomponents/settings/SettingsTemplate.vue';
import generateHash from '../../helpers/hashGenerator';

export default {
    components: {
        SettingsTemplate,
    },
    data() {
        return {
            menu: {
                label: `${this.$l10n.__('Signature électronique')} - ${this.$l10n.__(
                    'Service de signature électronique',
                )}`,
                isPlugin: true,
                sub: [
                    {
                        label: this.$l10n.__('Service de signature électronique'),
                        route: { name: 'settings.esign.providers' },
                        id: generateHash(),
                    },
                    {
                        label: this.$l10n.__('Préférences signature électronique'),
                        action: () => window.YousignPrefs.loadPrefs(),
                        id: generateHash(),
                    },
                ],
            },
        };
    },
};
</script>
